import { render, staticRenderFns } from "./DriverAppAssetDetail.vue?vue&type=template&id=2cee7e6f&scoped=true"
import script from "./DriverAppAssetDetail.vue?vue&type=script&lang=js"
export * from "./DriverAppAssetDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverAppAssetDetail.vue?vue&type=style&index=0&id=2cee7e6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee7e6f",
  null
  
)

export default component.exports